import {Component, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {LanguageService} from "../../shared/services/language.service";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {LinkComponent} from "../../shared/elements/link/link.component";
import {LayoutService} from "../../shared/services/layout.service";
import {AvatarComponent} from "../../shared/elements/avatar/avatar.component";
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {DialogService} from "../../shared/services/dialog.service";
import {ContentComponent} from "../../shared/elements/content/content.component";
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import {RouterService} from "../../shared/services/router.service";
import {LoadingService} from "../../shared/services/loading.service";
import { BreadcrumbModule } from '@syncfusion/ej2-angular-navigations';

@Component({
    selector: 'app-community-discussionsd',
    imports: [
        CommonModule,
        DialogModule,
        TranslatePipe,
        HeadlineComponent,
        FormInputComponent,
        FormButtonComponent,
        FormDropdownComponent,
        ToastModule,
        IconBadgeComponent,
        LinkComponent,
        AvatarComponent,
        TooltipModule,
        ContentComponent,
        TimePickerModule,
        BreadcrumbModule
    ],
    templateUrl: './community-discussionsd.component.html',
    styleUrl: './community-discussionsd.component.scss'
})
export class CommunityDiscussionsdComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  dialogService = inject(DialogService);
  routerService = inject(RouterService);
  loadingService = inject(LoadingService);


  imageSrc= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";
  imageSrc1= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";

  createDiscussion(): void{
    alert("Same as in the news");
  }
/**** FORM GROUP */
  public communityDiscussionForm: FormGroup = this.formBuilder.group({
    searchString: [''],
    search_filter: [''],
    discussion_filter: [''],
    community_topic_title: [''],
    community_topic_description: [''],
    community_topic_visibility: [0],
    join_by_invite_only: [''],
    community_likes_visibility: [0],
    community_views_visibility: [0],
    community_fallowers_visibility: [0]
  });

  discussionFilterOptions: any[] = [
    {id: 'all', name: this.languageService.getTranslationByKey('COMMUNITYALLDISCUSSIONSFILTER')},
    {id: 'unread', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYUNREADDISCUSSIONSFILTER')},
    {id: 'created_by_me', name: this.languageService.getTranslationByKey('COMMUNITYSHOWDISCUSSIONSONLYCREATEDBYMEFILTER')},
    {id: 'by_users', name: this.languageService.getTranslationByKey('COMMUNITYDISCUSSIONSSHOWBYUSERSFILTER')},
    {id: 'by_likes', name: this.languageService.getTranslationByKey('COMMUNITYDISCUSSIONSSHOWBYNUMBEROFLIKESFILTER')},
    {id: 'by_views', name: this.languageService.getTranslationByKey('COMMUNITYDISCUSSIONSSHOWBYNUMBEROFVIEWSFILTER')},
  ];

  public activeStep = 0;
  public participantsGroupIDs: number[] = [8,6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];
  public steps: string[] = [this.languageService.getTranslationByKey('COMMUNITYTOPICTEXTCONTENTMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSPLASHMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICEDITORPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSUBSCRIBERSPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSETTINGSMENUTEXT')];
}

